// extracted by mini-css-extract-plugin
export var contentBody = "_4e-9";
export var headerImage = "_4e-2";
export var imageButton = "_4e-7";
export var imageButtonIcon = "_4e-8";
export var imageHeader = "_4e-4";
export var imageHeaderText = "_4e-5";
export var imageOverlay = "_4e-3";
export var imageTitle = "_4e-6";
export var imageWrapper = "_4e-1";
export var taskList = "_4e-a";
export var widget = "_4e-0";